/**
 * drawerWrapperStyle
 *
 * Style for antd Drawer's `wrapper` semantic slot. `FormSidebar` and
 * `CompositeFieldSidebar` keep their width in `uiState` and pass their panel, so
 * the ceiling is that panel's `panelViewportClamp`. `LedgerAccountHistoryDrawer`,
 * `LedgerPaymentEntryDrawer`, `LedgerProposalDrawer` and `LedgerStatementImportDrawer`
 * pass no panel because their width is antd's `size="large"`; their ceiling is
 * `100%`, which keeps a fixed-size drawer inside a narrow viewport. The floor is a
 * CSS step at antd `md`: at `screenMD` and wider `(screenMD - 100vw) * 10000` is
 * <= 0, so the floor is 0 and the drawer's own width governs; below it `min` yields
 * `100%`, so the Drawer opens as a full-width overlay with no listener. `100vw`
 * caps that full-width step because on a phone whose layout viewport grew past the
 * device width, `100%` of the fixed Drawer root is that grown width.
 */

import type { CSSProperties } from 'react';
import type { GlobalToken } from 'antd';
import { panelViewportClamp } from '@/store/uiState';

type PanelKey = Parameters<typeof panelViewportClamp>[0];

export const drawerWrapperStyle = (
  token: GlobalToken,
  panel?: PanelKey,
): CSSProperties => ({
  maxWidth: panel === undefined ? '100%' : panelViewportClamp(panel),
  minWidth: `min(100%, 100vw, max(0px, calc((${token.screenMD}px - 100vw) * 10000)))`,
});
